export default {
  tags: "Tags",
  categories: "Categories",
  archive: "Archive"
};
